import FashionPreorderDevelopmentBreakdown from "~/components/demand-2/demand/FashionPreorderDevelopmentBreakdown"
import PreorderDevelopmentBreakdown from "~/components/demand-2/demand/PreorderDevelopmentBreakdown"
import {
  answersMoveNothing,
  type PreorderInsight,
  withEnginePreview,
} from "~/components/demand-2/shared/preorderDevelopment"
import type { AdaptationMode } from "~/utils/demandPreorderDevelopment"
import { formatName } from "~/utils/namingUtils"

/**
 * "Pre-order development" for the plan's kind: NOOS compares the book against 52 weeks ago;
 * fashion, with no trailing year, against the accepted comparables' pre-orders. One component so
 * callers don't each branch on kind.
 */
const PreorderBreakdown = ({ persistKey, data }: { persistKey: string; data: PreorderInsight }) =>
  data.kind === "fashion" ? (
    <FashionPreorderDevelopmentBreakdown persistKey={persistKey} data={data} />
  ) : (
    <PreorderDevelopmentBreakdown persistKey={persistKey} data={data} />
  )

export default PreorderBreakdown

/**
 * A slice's breakdown with each answer sized by the engine (`getPreorderSlicePreview`): a slice's
 * answer only reaches that slice's pre-orders still to come, which a share of the variant's can't see.
 */
export const SlicePreorderBreakdown = ({
  persistKey,
  data,
  preview,
}: {
  persistKey: string
  data: PreorderInsight
  preview: Record<AdaptationMode, number> | undefined
}) => (
  <div className="flex flex-col gap-3">
    {preview && answersMoveNothing(preview) && (
      <p className="max-w-[60ch] paragraph-sm text-fg-subtle">
        No {formatName("preorder", true)} are still to come here, so no answer changes the plan. The
        ones still to come are expected on other channels or markets.
      </p>
    )}
    <PreorderBreakdown
      persistKey={persistKey}
      data={preview ? withEnginePreview(data, preview) : data}
    />
  </div>
)
